import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const notasService = {
  importarNota,
  save,
};

function save(nota) {
  return defaultService.doPost(`${urlsConstants.API_NFS}save`, nota);
}
function importarNota(nota) {
  return defaultService.doPost(`${urlsConstants.API_NFS}`, nota);
}
